import { request } from './ChartConfigService';

// Config del modo Dashboard del chat (prompts del diseñador y de la
// reparación de mosaicos, modelos, límites y opciones). Vive en
// whisperbi-agent-management-strands (billing-admin/app.py, GET/PUT
// /dashboard-config, solo root), junto a /analysis-config y /chart-config.
const DashboardConfigService = {
  async getConfig() {
    return request('/dashboard-config', { method: 'GET' });
  },
  async upsertConfig(payload) {
    return request('/dashboard-config', { method: 'PUT', body: JSON.stringify(payload) });
  }
};

export default DashboardConfigService;
